// src/pages/ProjectExample.jsx
import './ProjectPage.css'; // separate CSS for project pages

import HeartBloom_img1 from '../../assets/images/HeartBloom_img1.gif';
import HeartBloom_img2 from '../../assets/images/HeartBloom_img2.gif';
import HeartBloom_img3 from '../../assets/images/HeartBloom_img3.gif';
import HeartBloom_img4 from '../../assets/images/HeartBloom_img4.gif';
import HeartBloom_img5 from '../../assets/images/HeartBloom_img5.gif';
import HeartBloom_img6 from '../../assets/images/HeartBloom_img6.webp';
import HeartBloom_img7 from '../../assets/images/HeartBloom_img7.jpg';
import HeartBloom_img8 from '../../assets/images/HeartBloom_img8.jpg';
import HeartBloom_img9 from '../../assets/images/HeartBloom_img9.jpg';
import HeartBloom_img10 from '../../assets/images/HeartBloom_img10.jpg';
import HeartBloom_img11 from '../../assets/images/HeartBloom_img11.jpg';
import HeartBloom_img13 from '../../assets/images/HeartBloom_img13.jpeg';
import HeartBloom_img14 from '../../assets/images/HeartBloom_img14.jpeg';
import HeartBloom_img15 from '../../assets/images/HeartBloom_img15.jpeg';
import HeartBloom_img16 from '../../assets/images/HeartBloom_img16.png';
import HeartBloom_img17 from '../../assets/images/HeartBloom_img17.png';
import HeartBloom_img18 from '../../assets/images/HeartBloom_img18.jpg';
import HeartBloom_img19 from '../../assets/images/HeartBloom_img19.jpg';        
import HeartBloom_img20 from '../../assets/images/HeartBloom_img20.jpg';
import HeartBloom_img21 from '../../assets/images/HeartBloom_img21.jpg';
import HeartBloom_img22 from '../../assets/images/HeartBloom_img22.jpg';



function HeartBloom() {
  return (
    <>


      <div className="project-page-wrapper">
        {/* Project title */}
        <h1 className="project-title">HeartBloom: Flowers Blooming with Each HeartBeat </h1>

        {/* Introduction text */}
        <p className="project-introduction">
            HeartBloom originated from biofeedback research as an exploration of a tangible interface that enables individuals to see, hear, and feel the rhythm of their hearts. 
            It also investigates a metaphorical visualization of heart rate variability, translating heartbeats into floral graphics that reflect the body’s natural biorhythms. 
            Over time, HeartBloom has evolved from a lab-based study into a public installation and a service design supporting sustainable charitable fundraising.
        </p>

       {/* Another image */}
        <div className="project-image">
             <img src={HeartBloom_img1} alt="HeartBloom 1" />
        </div>
        {/* Image */}
       

        {/* Details text */}
        <h2 className="section-title">HeartBloom, a Biofeedback Interface</h2>
        <p className="project-details-text">
            We often notice our heartbeat only during moments of excitement or fear, yet the heart is constantly changing its rhythm, even when we are unaware. 
            Biofeedback is a technique that measures physiological processes and quickly relays the information to users, helping them become aware of their bodily states. 
            Heart Bloom is a biofeedback interface that transforms this physiological data into a multisensory experience through mechanical movement, sound, and artistic visualization. 
            Each heartbeat triggers a movement, producing a line, while variations in heart rate are reflected in the pen’s behavior in real time. 
            The resulting drawings on paper visually express overall heart rate variability.
        </p>

        <div className="project-image-grid">
            <img src={HeartBloom_img2} alt="HeartBloom 2" />
            <img src={HeartBloom_img3} alt="HeartBloom 3" />
            <img src={HeartBloom_img4} alt="HeartBloom 4" />
            <img src={HeartBloom_img5} alt="HeartBloom 5" />
        </div>

         <div className="project-video">
            <iframe
                src="https://player.vimeo.com/video/188134735"
                width="100%"
                height="450"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Project Video"
            ></iframe>
        </div>


        <h2 className="section-title">HeartBloom, a Metaphorical Visualization</h2>
        <p className="project-details-text">
        We used images of flowers as a visual metaphor. In literature and culture, flowering plants are often associated with life and health—the phrase “flower of life” exemplifies this symbolism. 
        A blooming flower represents vitality and well-being, while a faded flower suggests fragility or imbalance. Similarly, a flexible heart rate (high HRV) indicates a balanced autonomic nervous system, 
        which is optimal for maintaining key physiological functions. In Heart Bloom, high HRV is depicted as a blooming flower with an organic shape and “petals” radiating outward from the center. The figure below shows a collective drawing
        representing data from multiple participants. Like fingerprints, each flower pattern reflects the temporal uniqueness of an individual heartbeat, capturing the distinctive rhythm of one’s life.
        </p>
       {/* Another image */}
        <div className="project-image">
             <img src={HeartBloom_img10} alt="HeartBloom 10" />
        </div>
        {/* Image */}

        <h2 className="section-title">HeartBloom, a Public Interactive Installation</h2>
        <p className="project-details-text">
         From the perspective of service and activity design, HeartBloom offers a new lens for thinking about healthcare and social impact. It functions as a public-spirited activity, empowering community members to support socially vulnerable groups. 
         HeartBloom invites people to listen to, engage with, and care about the stories of children with congenital heart disease. At this stage, the focus extends beyond designing a product or system to understanding how people participate, engage publicly, and what they experience and learn. 
         In our design practice, HeartBloom has evolved from a biofeedback device and physical visualization tool into a creative platform, a public activity, and a social service.
         In November 2015, Heart Bloom was exhibited in Dubai Design Week.  HeartBloom transforms the participant’s heartbeat data into a blooming flower on a postcard, 
         which is then mailed to the beloved ones with special and ‘heartful’ greetings, shortening the distance of the heart and heart.
        </p>

        <div className="project-image-grid">
            <img src={HeartBloom_img6} alt="HeartBloom 6" />
            <img src={HeartBloom_img7} alt="HeartBloom 7" />
            <img src={HeartBloom_img8} alt="HeartBloom 8" />
            <img src={HeartBloom_img9} alt="HeartBloom 9" />
        </div>

        <div className="project-image">
             <img src={HeartBloom_img11} alt="HeartBloom 11" />
        </div>

        {/* Section 3*/}
        <h2 className="section-title">HeartBloom, a Design-driven Charity Initiative</h2>
        <p className="project-details-text">
          With Heart Bloom, we participated in a series of charitable public events organized by the Hartstichting, bringing the installation to children with heart disease. 
          Interacting with Heart Bloom allows them to see, hear, and feel the “seed” inside their body bloom into a flower with every heartbeat. The project conveys a positive message: each child is special, and although the hearts of children with CHD may function differently, 
          they create unique and beautiful “flowers.” We also believe these activities strengthen children’s relationships with their own hearts, foster connections with their families, and build friendships among peers who share similar experiences.
        </p>

        <div className="project-image-grid">
            <img src={HeartBloom_img13} alt="HeartBloom 13" />
            <img src={HeartBloom_img14} alt="HeartBloom 14" />
            <img src={HeartBloom_img15} alt="HeartBloom 15" />
            <img src={HeartBloom_img16} alt="HeartBloom 16" />
        </div>
        
        <div className="project-image">
           <img src={HeartBloom_img17} alt="HeartBloom 17" />
        </div>


         {/* Section 4*/}
        <h2 className="section-title">HeartBloom, a Charitible Fundraising Service Design </h2>
        <p className="project-details-text">
            Since Dutch Design Week 2016, Heart Bloom has functioned as a charitable fundraising service for the Hartstichting (Dutch Heart Foundation). The on-site installation invited visitors to participate in the charity by creating a unique Heart Bloom card through interaction with the system. 
            These individual cards were later assembled into a collective artwork that highlights the diversity of heart rhythms while raising awareness of congenital heart disease. To extend engagement, we developed the Heart Bloom fundraising website, which allows participants to access their personal heart-bloom pattern and connects
            them directly to the Dutch Heart Foundation for online donations. In this initial phase, we introduced a data-driven approach aimed at transforming one-time contributions into a sustainable fundraising model. Participants’ heartbeat data, captured during the installation, could be turned into personalized artworks—such as flower prints—with each order generating a €5–20 donation. 
            The ongoing creation and updating of these data-driven artworks helps maintain participant engagement and supports continued contributions to the charity.
        </p>

         <div className="project-video">
            <iframe
                src="https://player.vimeo.com/video/188135542"
                width="100%"
                height="450"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="HeartBloom Charity Event Video"
            ></iframe>
        </div>

        <div className="project-image-grid">
            <img src={HeartBloom_img18} alt="HeartBloom 18" />
            <img src={HeartBloom_img19} alt="HeartBloom 19" />
            <img src={HeartBloom_img20} alt="HeartBloom 20" />
            <img src={HeartBloom_img21} alt="HeartBloom 21" />
        </div>

        <div className="project-image">
             <img src={HeartBloom_img22} alt="HeartBloom 22" />
        </div>

         {/* Section 4*/}
        <h2 className="section-title">HeartBloom, a Mobile Fundraising Service</h2>
        <p className="project-details-text">
            Discover the unique rhythm of your heart with Heart Bloom Mobile. This Ipad application measures your heart rate and translates it into a flower-shaped graphic. Every heart has it's own rhythm that is under influence of the body and by external factors.
            Because of this every Heart Bloom card is unique. Print your card directly of send it by e-mail to your family or friends. 
            And don't forget to give a donation to the Dutch Heart Foundation to support them in their fight against heart diseases.
        </p>

         <div className="project-video">
            <iframe
                src="https://player.vimeo.com/video/771938408"
                width="100%"
                height="450"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="HeartBloom Charity Event Video"
            ></iframe>
        </div>



        {/* Footer: financing and partners */}
        <div className="project-footer">
          <p><strong>More information:</strong>  <a href="https://heartbloom.rogierarents.nl/" target="_blank" rel="noopener noreferrer">Heart Bloom Website</a></p>
          <p><strong>Collaborative designer:</strong>  <a href="https://www.rogierarents.nl/" target="_blank" rel="noopener noreferrer">Studio Rogier Arents</a></p>
          <p><strong>Project partner</strong>  <a href="https://www.hartstichting.nl/" target="_blank" rel="noopener noreferrer">Dutch Heart Foundation</a></p>
          <p><strong>Exhibitions:</strong>Psynapse gallery, Rotterdam, NL (2019)     RIXc, Riga, LV (2018);   Riga Photography Biennial, LV (2018);   Extrapool, Nijmegen, NL (2018);   Wanted Design, New York, USA (2017);   Dutch Design Week, Eindhoven, NL (2016);   Manifeest, Stadsschouwburg Ambsterdam, NL (2016);   Night or the Nerds, Eindhoven, NL (2016);   Designkwartier, Den Haag, NL (2016);   Dubai Design Week, UE (2015)</p>
         <p><strong>Publications:</strong>  <a href="https://doi.org/10.1145/2851581.2892289" target="_blank" rel="noopener noreferrer">HeartPlotter: Visualizing Bio-data by Drawing on Paper（CHI 2016）</a></p>
        </div>
      </div>
    </>
  );
}

export default HeartBloom;
